import React from 'react';
import ServiceCard from './ServiceCard';
import services from '../data/services';
import '../styles/ServicesGrid.css';

const ServicesGrid = () => (
    <div className="services-grid-container">
        {services.map((service, index) => (
            <div key={index} className="service-wrapper">
                <ServiceCard {...service} />
            </div>
        ))}
    </div>
);

export default ServicesGrid;
